import { render, staticRenderFns } from "./ParcelAdditionsDeductionsSection.vue?vue&type=template&id=e6e01718&scoped=true&"
import script from "./ParcelAdditionsDeductionsSection.vue?vue&type=script&lang=js&"
export * from "./ParcelAdditionsDeductionsSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelAdditionsDeductionsSection.vue?vue&type=style&index=0&id=e6e01718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e01718",
  null
  
)

export default component.exports